export enum Profiles {
  WORKER = "workers",
  SOW = "sows",
  SUBCONTRACTOR = "subcontractors",
  CONSOLIDATED_WORKER = "consolidatedworker",
}

export enum WorkItemProfiles {
  WORKER = "workers",
  SOW = "sows",
  SOWADM = "sowsAdm",
  SUBCONTRACTOR = "subcontractors",
  "CONSOLIDATED WORKER" = "consolidatedworkers",
}
